import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const PersonalDetailsCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { inc_title, inc_email, inc_picture, inc_summary, inc_workexperiencedescription } = state

  return (
    <CVCard title={t('CVTemplates.PersonalDetails')} description={t('CVTemplates.PersonalDetailsAndIntro')}>
      <Grid item>
        <OPCheckBox name='inc_title' label={t('CVTemplates.Title')} value={inc_title} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_email' label={t('CVTemplates.Email')} value={inc_email} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_picture' label={t('CVTemplates.Picture')} value={inc_picture} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_summary' label={t('Profile.ProfileSummary')} value={inc_summary} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_workexperiencedescription'
          label={t('Profile.ProfileWorkExperienceDescription')}
          value={inc_workexperiencedescription}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
